import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useOAT } from 'common/providers/oatProvider';

const gtmId = process.env.GATSBY_GOOGLE_TAG_MANAGER;

const Analytics = () => {
  const { clientId, restaurantId } = useOAT();

  const shouldTrack = !!(clientId && restaurantId);

  useEffect(() => {
    if (shouldTrack) {
      TagManager.initialize({
        gtmId,
        dataLayer: {
          oatClientId: clientId,
          oatRestaurantId: restaurantId,
        },
      });
    }
  }, [clientId, restaurantId, shouldTrack]);

  return null;
};

export default Analytics;
